import React, { useState, useEffect } from "react";

import Modal from "react-bootstrap/Modal";

import moment from "moment";

import ContractComponent from "../Contract/List/Component.js";
import ContractView from "../Contract/List/View.js";

const RecontractStatusViewModal = ({ branchId, nurseryId, bizApp, serviceAppList, nurseryName, list, seasonInfo, directorName, address, showModal }) => {
    const [show, setShow] = useState(showModal || false);
    const [bizAppMap, setBizAppMap] = useState(false);
    const [contractList, setContractList] = useState(false);
    useEffect(() => {
        setShow(showModal);
        if (showModal) {
            initModal(bizApp, list ? JSON.parse(JSON.stringify(list)) : list);
        }
        return () => {};
    }, [branchId, nurseryId, bizApp, nurseryName, list, showModal]);
    useEffect(() => {
        return () => {};
    }, [bizAppMap]);

    const initModal = (bizApp, list) => {
        if (bizApp && serviceAppList && list) {
            const newBizAppMap = ContractComponent.func.getBizAppMap(bizApp, null);
            list.sort((a, b) => {
                return a.age - b.age === 0 ? a.class_name - b.class_name : a.age - b.age;
            });
            setContractList(list);
            updateContractTotal(newBizAppMap, list);
        }
    };
    const updateContractTotal = (bizAppMap, list) => {
        if (bizAppMap) {
            let newBizAppMap = { ...bizAppMap };
            Object.keys(bizAppMap).forEach((a) => {
                newBizAppMap[a].count = 0;
                newBizAppMap[a].quantity = 0;
            });
            list.forEach((c) => {
                if (c.is555) return;
                Object.keys(bizAppMap).forEach((a) => {
                    if (bizAppMap[a].info && c.app_auth[a] && c[bizAppMap[a].info.quantity.field[0]] && (c.app_auth[a].approval === "AP")) {
                        newBizAppMap[a].count++;
                        newBizAppMap[a].quantity += Number(c[bizAppMap[a].info.quantity.field[0]]);
                    }
                });
            });
            setBizAppMap(newBizAppMap);
        }
    };

    if(!bizAppMap || !serviceAppList || !list) {
        return <></>;
    }

    return (
        <>
            <Modal
                className={`modal-contract modal-container fullscreen-modal`}
                show={show}
                onHide={() => {
                    setShow(false);
                }}
                aria-labelledby="example-custom-modal-styling-title"
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title font-14">재계약 현황</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-0">
                    <div className="row m-0 bg-primary-light">
                        <div className="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12">
                            <div className="page-header ml-2 mt-3 mb-3">
                                <h3 className="">
                                    {nurseryName}
                                    <span className="text-muted">{` (${directorName || "-"}, ${address || "-"})`}</span>
                                </h3>
                            </div>
                        </div>
                        <div className="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12" />
                    </div>
                    <div className="row m-0">
                        <div className="col">
                            <RecontractStatusTable bizApp={bizAppMap} list={contractList} seasonInfo={seasonInfo} serviceAppList={serviceAppList} />
                        </div>
                    </div>

                    <div className="row m-3">
                        <div className="col-xl-6 col-lg-6 col-md-6 col-sm-5 col-12" />
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-2 col-12" />
                        <div className="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12">
                            <button className="btn btn-info btn-rounded btn-block" onClick={() => setShow(false)}>
                                확인
                            </button>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};

const RecontractStatusTable = (props) => {
    useEffect(() => {
        return () => {};
    }, [props.bizApp, props.serviceAppList, props.list, props.seasonInfo]);

    let recontractYearCheck = props.seasonInfo.recontractYear;

    return (
        <>
            <div className="row mt-3">
                <div className="col">
                    <h5 className="text-muted"> &lt;{recontractYearCheck} 계약 수량&gt;</h5>
                </div>
            </div>
            <div className="div-table-contract">
                <div className="row">
                    <div className="col">
                        <ContractView.ContractViewRecontract tableId={"createTable"} seasonInfo={props.seasonInfo} bizApp={props.bizApp} serviceAppList={props.serviceAppList} list={props.list} />
                    </div>
                </div>
            </div>
        </>
    );
};

export default RecontractStatusViewModal;
